import React, {Component, Fragment} from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import {Mutation} from 'react-apollo';
import Toolbar from '../common/Toolbar';
import Title from '../common/Title';
import FlatButton from '../common/FlatButton';
import {login as saveLoginInfo} from '../../utils/auth';

const LoginCard = styled.form`
  padding: ${({theme}) => theme.spacingVertical(2)} ${({theme}) => theme.spacingHorizontal(2)};
  background-color: ${({theme}) => theme.lightGray};
  margin-top: 200px;
  align-self: center;
  width: 700px;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  display: block;
  font-size: ${({theme}) => theme.fontMedium};
  margin-top: ${({theme}) => theme.spacingVertical()};
`;

const Input = styled.input`
  display: block;
  width: 100%;
  margin-bottom: ${({theme}) => theme.spacingVertical(2)};
  margin-top: ${({theme}) => theme.spacingVertical()};
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 2px solid ${({theme}) => theme.black};
  &:focus {
    border-bottom: 2px solid ${({theme}) => theme.primaryColor};
  }
  font-size: ${({theme}) => theme.fontMedium};
`;

const Flex = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
`;

const ErrorMessage = styled.div`
  color: ${({theme}) => theme.red};
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
  font-size: ${({theme}) => theme.fontMedium};
  text-align: center;
`;

const BrowserInfo = styled.div`
  margin-top: 20px;
  font-size: 12px;
  color: ${props => props.theme.primaryColor};
`;

const loginMutation = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      user {
        jwtToken
        companyId
      }
    }
  }
`;

export default class LoginPage extends Component {
  state = {username: '', password: ''};

  onUsernameChange = ({target}) => this.setState({username: target.value});

  onPasswordChange = ({target}) => this.setState({password: target.value});

  renderErrorMessage = e => (e ? <ErrorMessage>{e.message}</ErrorMessage> : null);

  renderLoginButton = () => (
    <Mutation mutation={loginMutation}>
      {(login, {loading, error, data: {login: {user: {jwtToken, companyId} = {}} = {}} = {}}) => {
        if (jwtToken) {
          saveLoginInfo(jwtToken, companyId);
          this.props.rerender();
        }
        return (
          <Flex>
            <FlatButton
              disabled={loading}
              type="submit"
              onClick={() => {
                const {username, password} = this.state;
                login({variables: {input: {username, password}}});
              }}>
              Login
            </FlatButton>
            {this.renderErrorMessage(error)}
          </Flex>
        );
      }}
    </Mutation>
  );

  render() {
    return (
      <Fragment>
        <Toolbar renderCenterContent={() => <Title>Login</Title>} />
        <LoginCard>
          <Label>
            Benutzername:
            <Input value={this.state.username} onChange={this.onUsernameChange} />
          </Label>
          <Label>
            Passwort:
            <Input type="password" value={this.state.password} onChange={this.onPasswordChange} />
          </Label>
          {this.renderLoginButton()}
          <BrowserInfo>Chrome & Firefox supported</BrowserInfo>
        </LoginCard>
      </Fragment>
    );
  }
}
